export const formatByHashes = (mask: string, value: string) => {
  let i = 0;
  return mask.replace(/#/g, () => value[i++] || '');
};

export const formatPhone = (phone: string) => {
  const strToFormat = phone.replace(/\D+/g, '');
  return formatByHashes('+# (###) ###-##-##', strToFormat);
};
